import {Component, ViewChild} from "@angular/core";

@Component({
  selector: "core-viewchild-child",
  template: `<p>{{text}}</p>`
})
class ChildComponent {
  private text = "";

  setText(text: string) {
    this.text = text;
  }
}

@Component({
  selector: 'core-viewchild',
  template: `
  <usecase-container title="ViewChild" src="core/viewchild">
    <usecase-content>
      <core-viewchild-child></core-viewchild-child>
    </usecase-content>
  </usecase-container>
  `,
  directives: [
    ChildComponent
  ]
})
export class ViewChildComponent {
  @ViewChild(ChildComponent) child: ChildComponent;

  ngAfterViewInit() {
    // run in next turn
    setTimeout(() => {
      this.child.setText("Angular 2");
    }, 0);
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/viewchild/component.ts
 **/